"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setHasSearchedDirectory')(function setHasSearchedDirectory(viewstate, hasSearchedDirectory) {
    viewstate.hasSearchedDirectory = hasSearchedDirectory;
});
//# sourceMappingURL=setHasSearchedDirectory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/setHasSearchedDirectory.js
// module id = 2822
// module chunks = 2 3 4 45